/**
 * @desc 设备号
 * @author ruoxinhuang
 * @date 2021-09-09
 */
// 注意按需引用, 控制包大小
import WordArray from 'crypto-js/lib-typedarrays';
export function getDeviceId() {
    var deviceId = localStorage.getItem('deviceId');
    if (!deviceId) {
        var randomStr = WordArray.random(16).toString();
        deviceId = "".concat(randomStr, "-").concat(Date.now(), "-").concat(Math.floor(Math.random() * 1000000));
        localStorage.setItem('deviceId', deviceId);
    }
    console.log('deviceId', deviceId);
    return deviceId;
}
